"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzPagination = void 0;

var react_1 = __importDefault(require("react"));

var react_js_pagination_1 = __importDefault(require("react-js-pagination"));

var SzButton_1 = __importDefault(require("../SzButton/SzButton"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

var SzTypographie_1 = __importDefault(require("../SzTypographie/SzTypographie"));

require("./SzPagination.scss");

exports.SzPagination = function (_a) {
  var totalItemsCount = _a.totalItemsCount,
      activePage = _a.activePage,
      onChange = _a.onChange,
      itemsCountPerPage = _a.itemsCountPerPage,
      pageRangeDisplayed = _a.pageRangeDisplayed,
      variant = _a.variant;
  var prevIcon = variant ? 'arrow-left-1' : 'navigation-left-circle-1_1';
  var nextIcon = variant ? 'arrow-right-1' : 'navigation-right-circle-1_1';
  var firstPageText = react_1.default.createElement(SzIcon_1.default, {
    variant: "line",
    icon: "button-next"
  });
  var lastPageText = react_1.default.createElement(SzIcon_1.default, {
    variant: "line",
    icon: "button-previous"
  });
  var prevPageText = react_1.default.createElement(SzIcon_1.default, {
    variant: "bold",
    icon: prevIcon
  });
  var nextPageText = react_1.default.createElement(SzIcon_1.default, {
    variant: "bold",
    icon: nextIcon
  });

  var nextPageChange = function nextPageChange() {
    var nextPage = activePage + 1 <= totalItemsCount ? activePage + 1 : totalItemsCount;
    onChange(nextPage);
  };

  var prevPageChange = function prevPageChange() {
    var prevPage = activePage - 1 === 0 ? 1 : activePage - 1;
    onChange(prevPage);
  };

  if (variant === 'custom') {
    return react_1.default.createElement("div", {
      className: "sz-pagination d-flex align-items-center"
    }, react_1.default.createElement(SzButton_1.default, {
      small: true,
      variant: "contained",
      icon: prevIcon,
      iconVariant: "bold",
      border: "rounded",
      onClick: prevPageChange
    }), react_1.default.createElement("div", {
      className: "sz-pagination-count px-2"
    }, react_1.default.createElement(SzTypographie_1.default, {
      tag: "span"
    }, activePage, "/", totalItemsCount)), react_1.default.createElement(SzButton_1.default, {
      small: true,
      variant: "contained",
      icon: nextIcon,
      iconVariant: "bold",
      border: "rounded",
      onClick: nextPageChange
    }));
  }

  return react_1.default.createElement(react_js_pagination_1.default, {
    activePage: activePage,
    itemsCountPerPage: itemsCountPerPage,
    totalItemsCount: totalItemsCount,
    pageRangeDisplayed: pageRangeDisplayed,
    onChange: onChange,
    itemClass: "page-item",
    linkClass: "page-link",
    innerClass: "sz-pagination pagination align-items-center",
    hideDisabled: true,
    firstPageText: variant ? null : firstPageText,
    lastPageText: variant ? null : lastPageText,
    prevPageText: prevPageText,
    nextPageText: nextPageText,
    linkClassFirst: "text-primary-dark",
    linkClassLast: "text-primary-dark",
    linkClassPrev: "text-primary-dark",
    linkClassNext: "text-primary-dark"
  });
};

exports.default = exports.SzPagination;